import { useEffect, useRef, useState } from 'react';

export default function AboutSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToCareer = () => {
    const element = document.getElementById('career');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="about" className="py-4 px-6 lg:px-12 bg-white" ref={sectionRef}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 items-center">
          <div className="space-y-8">
            <div
              className={`space-y-4 text-gray-700 leading-relaxed transition-all duration-700 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              <p className="text-lg lg:text-xl">
                <strong className="font-semibold text-gray-900">名前：</strong>Tatsuya Miwa
              </p>
              <p className="text-lg lg:text-xl">
                <strong className="font-semibold text-gray-900">年齢：</strong>26歳
              </p>
              <p className="text-lg lg:text-xl">
                <strong className="font-semibold text-gray-900">職業：</strong>パーソナルトレーナー
              </p>
            </div>

            <div
              className={`transition-all duration-700 delay-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            >
              <button
                onClick={scrollToCareer}
                className="text-gray-900 font-medium underline underline-offset-4 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
              >
                経歴を見る →
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-6">
                <div className="rounded-2xl overflow-hidden shadow-lg aspect-square">
                  <img
                    src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/740dac4f0645f8ac93285848f24fa946.jpeg"
                    alt="Training"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg aspect-square">
                  <img
                    src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/c1295b82b69c2f6d447426c7a9096675.jpeg"
                    alt="Photo 3"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="space-y-6 pt-12">
                <div className="rounded-2xl overflow-hidden shadow-lg aspect-square">
                  <img
                    src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/f6ad5ad82f41c5ce495f38564300f181.jpeg"
                    alt="Portrait"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg aspect-square">
                  <img
                    src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/63aced104c1d1fffe4966f3b9d13f243.jpeg"
                    alt="Gym"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
